import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import UsersTable from "../components/UsersTable";
import { ToastContainer } from 'react-toastify';

const UsersStaffPage = () => {
  return (
    <MasterLayout>
      <ToastContainer />
      <Breadcrumb title="Personeller" />
      <UsersTable role="staff" title="Personeller" />
    </MasterLayout>
  );
};

export default UsersStaffPage;

